<template>
  <b-overlay :show="loading">
    <b-container fluid>

      <b-row align-h="center">
        <b-col cols="12" md="8" lg="6">

          <b-alert v-if="error" show variant="danger" class="mt-2">
            {{errorMsg}}
            <!-- TBD error component. -->
          </b-alert>

          <div v-if="!error">
            <transition name="fade" mode="out-in">
              <div v-if="!busy" key="part1">
                <b-row>
                  <b-col>
                    <!-- <b-col cols="12" lg="6" offset-lg="3"> -->
                    <div class="headline">{{webinar.title}}</div>
                    <div v-show="!isGraded && !passed" class="blurb mb-2">
                      A score of {{exam.minScore}}% or greater is required to complete this course.
                    </div>
                    <b-alert :show="isGraded && !passed" variant="danger">
                      Your score of {{examScore}}% is insufficient to pass this course.
                      <br>A score of {{exam.minScore}}% or greater is required.
                      <br>Review your answers and re-submit exam.
                    </b-alert>
                    <b-alert :show="passed" class="mt-2" variant="success">
                      <h3>Congratulations! You've earned CE credit. Grade: {{examScore}}%</h3>
                      <div>For your convenience the graded exam is below.</div>
                      <div class="text-center">
                        <b-button size="sm" @click="gotoClass">Return to Classroom</b-button>
                      </div>
                    </b-alert>
                  </b-col>
                </b-row>
              </div>
              <div v-else key="part2">
                <b-alert show variant="warning">
                  Please wait while exam is loaded.
                </b-alert>
              </div>
            </transition>

            <!-- https://bootstrap-vue.js.org/docs/components/input-group -->
            <b-form v-show="!busy" @submit.prevent="submitExam">
              <b-overlay :show="grading">
                <b-row v-for="(row,index) in exam.questions" v-bind:key="row.examQId" class="mt-2">
                  <!-- index starts zero -->
                  <b-col>
                    <b-row>
                      <b-col class="exam-question">
                        Q{{index+1}}. {{row.question}}
                      </b-col>
                    </b-row>

                    <b-form-group label>
                      <b-form-radio
                        v-if="row.option1 !== null"
                        v-model="selected[index]"
                        value="1"
                        :class="[radioClassArr,{'correct': isCorrect(index,1)},{'incorrect': isIncorrect(index,1)}]"
                      >a. {{row.option1}}</b-form-radio>
                      <b-form-radio
                        v-if="row.option2 !== null"
                        v-model="selected[index]"
                        value="2"
                        :class="[radioClassArr,{'correct': isCorrect(index,2)},{'incorrect': isIncorrect(index,2)}]"
                      >b. {{row.option2}}</b-form-radio>
                      <b-form-radio
                        v-if="row.option3 !== null"
                        v-model="selected[index]"
                        value="3"
                        :class="[radioClassArr,{'correct': isCorrect(index,3)},{'incorrect': isIncorrect(index,3)}]"
                      >c. {{row.option3}}</b-form-radio>
                      <b-form-radio
                        v-if="row.option4 !== null"
                        v-model="selected[index]"
                        value="4"
                        :class="[radioClassArr,{'correct': isCorrect(index,4)},{'incorrect': isIncorrect(index,4)}]"
                      >d. {{row.option4}}</b-form-radio>
                      <b-form-radio
                        v-if="row.option5 !== null"
                        v-model="selected[index]"
                        value="5"
                        :class="[radioClassArr,{'correct': isCorrect(index,5)},{'incorrect': isIncorrect(index,5)}]"
                      >e. {{row.option5}}</b-form-radio>
                      <b-form-radio
                        v-if="row.option6 !== null"
                        v-model="selected[index]"
                        value="6"
                        :class="[radioClassArr,{'correct': isCorrect(index,6)},{'incorrect': isIncorrect(index,6)}]"
                      >f. {{row.option6}}</b-form-radio>
                    </b-form-group>

                  </b-col>
                </b-row>

                <b-alert :show="!studentData.agdNumber && !studentData.hideAgdReminder" variant="info" class="mt-2">
                  <!-- We do not have your AGD number on file. -->
                  <b>ATTENTION AGD MEMBERS:</b>
                  If you would like us to start reporting your CE credits to the Academy of General Dentistry, go to the Account Profile page and enter your AGD member number after you pass this exam.

                  <div class="mt-2">
                    <b-form-checkbox
                      id="hide-agd-reminder"
                      v-model="hideAgdReminder"
                      name="hide-agd-reminder"
                      value="true"
                      unchecked-value="false"
                      @input="checkAgdReminder"
                    >
                      Do not show this reminder again.
                    </b-form-checkbox>
                  </div>
                </b-alert>

              </b-overlay>

              <transition name="fade" mode="out-in">
                <b-alert v-model="errorGrading" key="error-box" show variant="danger" dismissible class="mt-2">
                  {{errorMsg}}
                </b-alert>
              </transition>

              <b-row v-show="!grading && !passed">
                <b-col>
                  <b-button :disabled="isExamDisabled" type="submit" variant="primary" class="mt-2 w-100">Submit Exam</b-button>
                  <div>  <!-- alert banners -->
                    <b-alert :show="isExamDisabled" variant="danger" class="mt-2"><b>Exam Limit Reached:</b> You’ve reached the limit of 10 exams per day.  Please resume your self-study activity another day.</b-alert>
                  </div>
                </b-col>
              </b-row>

              <b-row v-show="grading">
                <b-col>
                  <b-button disabled type="button" variant="primary" class="mt-2 w-100">Grading...</b-button>
                </b-col>
              </b-row>

              <transition name="fade" mode="out-in">
                <b-row v-show="passed">
                  <b-col>
                    <b-alert :show="passed" variant="success">
                      <h3>Congratulations! You've earned CE credit. Grade: {{examScore}}%</h3>
                      <div>Scroll up to see graded exam.</div>
                    </b-alert>
                  </b-col>
                </b-row>
              </transition>

            </b-form>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
'use strict'
/* eslint-disable */

import service from "@/service/service"
import utils from "@/utils/utils"
import constants from "@/config/constants"

export default {
  name: "Exam",
  data() {
    return {
      debug: false,
      loading: true,
      error: false,
      errorGrading: false,  // true if error when grading exam
      examDelayMin: 0,    // minute delay before taking exam after fails
      hideAgdReminder: false,
      errorMsg: null,
      busy: false,
      grading: false,
      msg: "Exam",
      blurb: "",
      webinar: {},
      studentData: { status: false, ceTypeId: 0, examsLeftToday: -1 },
      exam: {},
      examScore: 0,
      passed: false,
      studentHash: this.$root.getToken(),
      classHash: "",
      selected: [],   // model for each button group
      answers: [],    // static set of selected choices - set at poit of grading
      grades: [],
      radioClassArr: ["pt-1", "pb-1", "mb-1", "radio-exam"]
    }
  },
  props: {
    // route set to use props mapped to url parameters
    c: {
      type: String,
      required: true,
      default: ""
    }
  },
  components: {},
  computed: {
    isGraded() {
      // return true if exam is graded
      return this.grades.length !== 0
    },
    haveAnswers() {
      // return true if exam is graded
      return this.answers.length !== 0
    },
    isExamDisabled() {
      let aout = (this.studentData.ceTypeId == constants.CE_TYPEID.HOMESTUDY && this.studentData.examsLeftToday <= 0)
      if (this.debug) console.log(`isExamDisabled: aout: ${aout} constants.CE_TYPEID.HOMESTUDY: ${constants.CE_TYPEID.HOME_STUDY} ceTypeId: ${this.studentData.ceTypeId}  examsLeftToday: ${this.studentData.examsLeftToday}`)
      return aout
    }
  },
  methods: {
    gotoClass() {
      this.$router.push(`/classroom/${this.classHash}`)
    },
    isCorrect(quesIndex, ansIndex) {
      // return true if exam is graded and item is selected and correct.
      // or if exam passed and answer is the correct one
      let aout = false
      if ( !this.grading
          && this.haveAnswers
          && ansIndex == this.answers[quesIndex]
          && this.grades[quesIndex]
      ) {
        aout = true
      }
      else if ( this.passed
          && ansIndex == this.exam.questions[quesIndex].correctOption
      ) {
        aout = true
      }
      // console.log(`isCorrect(${quesIndex},${ansIndex}) ${aout}`)
      return aout
    },
    isIncorrect(quesIndex, ansIndex) {
      // return true if exam is graded and item is selected and incorrect.
      let aout = false
      if ( !this.grading
          && this.haveAnswers
          && ansIndex == this.answers[quesIndex]
          && !this.grades[quesIndex]
      ) {
        aout = true
      }
      // console.log(`isIncorrect(${quesIndex},${ansIndex}) ${aout}`)
      return aout
    },
    clearAnswers() {
      this.answers = []
    },
    checkAgdReminder () {  // tied to input event not change.
      // console.log(`hideAgdReminder: ${this.hideAgdReminder}`)
      if (!this.studentData.hideAgdReminder && this.hideAgdReminder === "true") {
        if (this.debug) console.log(`hideAgdReminder: ${this.hideAgdReminder}`)
        this.studentData.hideAgdReminder = true  // one time event
        // update student record
        service
          .hideAgdReminder(this.studentHash)
          .then(
            (res => {
              console.log(`Data updated.`)
            }).bind(this)
          )
          .finally(
            (() => {
              if (this.debug) console.log(`finally...`)
            }).bind(this)
          )
          .catch( e => {
            console.log(e)
          })
      }
    },
    submitExam(e) {
      // e.preventDefault();   // uses submit.prevent
      this.error = false
      this.errorGrading = false
      this.clearAnswers()
      // console.log(`json: ${this.exam.questions.length}  form: ${this.selected.length} `)
      if (this.exam.questions.length === this.selected.length) {
        this.grading = true
        this.grades = []
        // All answers present
        let examData = {
          s: this.studentHash,
          c: this.classHash,
          p: null,
          a: this.selected
        }
        service
          .gradeExam(examData)
          .then(
            (res => {
              // console.log(`back from gradeExam!`)
              // if (this.debug) console.log(this.$refs)
              if (res.status) {
                this.exam = res.exam   // get correctOption on questions
                this.examScore = res.examScore
                this.passed = res.passed
                this.grades = res.grades // Array T/F for each question
                this.answers = this.selected.slice()  // clone array
                this.examDelayMin = res.examDelayMin
                if (this.debug) console.log(`GradeExam ExamDelayMin: ${this.examDelayMin}`)
              } else {
                console.log(`Error from grade-exam.`)
                this.errorMsg = res.msg
                this.error = true
              }
            }).bind(this)
          )
          .finally(
            (() => {
              // console.log(`finally grade exam...`)
              this.grading = false
              document.getElementById('app').scrollIntoView()  // scroll to top of page.
            }).bind(this)
          )
          .catch(e => {
            this.grading = false
            this.error = true
            this.errorMsg = "Technical Error. Try again later."
            console.log(e)
          });
      } else {
        // missing answers
        this.errorMsg = "Please answer all questions."
        this.errorGrading = true
      }
    },
  },
  created() {
    this.classHash = this.c || this.$route.query.c || this.$root.getClassHash() || null

    if (this.classHash) {
      this.busy = true
      service
        .getExam(this.classHash, null, this.studentHash)
        .then(
          (res => {
              // console.log(`back from getExam!`);
            if (res.status && res.exam.status) {
                if (res.exam) {
                    this.exam = res.exam
                    this.examDelayMin = res.examDelayMin
                    if (this.debug) console.log(`Created ExamDelayMin: ${this.examDelayMin}`)
                }
                if (res.studentData && res.studentData.status) {
                  this.studentData = res.studentData
                  if (this.debug) console.log(`Created examsLeftToday: ${this.studentData.examsLeftToday}`)
                  if (!this.studentData.evalTaken) {
                    alert('Complete evaluation before completing exam.')
                    this.$router.push({ path: `/eval/${this.classHash}` })
                  }
                  if (this.studentData.examTaken) {
                    alert('Exam completed.  Returning to classroom.')
                    this.gotoClass()
                  }
                }
                else {
                  alert('Unable to load student.  Returning to classroom.')
                  this.gotoClass()
                }
                this.webinar = {
                    classId: res.classId,
                    title: res.title,
                    credits: res.credits,
                    releaseDate: res.releaseDate,
                    ceTypeId: this.studentData.ceTypeId
                }
            }
            else {
              this.errorMsg = "Exam not available.  Try again later."
              this.error = true;
            }
          }).bind(this)
        )
        .finally(
          (() => {
            this.busy = false
            this.loading = false
            if (this.debug) console.log(`CREATED finally...`)
          }).bind(this)
        )
        .catch( e => {
          this.errorMsg = "Technical error.  Contact support."
          this.error = true
          console.log(e)
        })
    }
    else {
      // classhash not provided
      this.$router.push("/pending");
    }
  },
  mounted() {
    this.passed = false
    this.errorGrading = false
    this.grades = []
    this.clearAnswers()
    this.examDelayMin = 0

    for(let ix=0; ix < this.selected.length; ix++) {
      this.selected[ix] = 0
    }
    if (this.debug) console.log(`MOUNTED...`)
  },
  beforeDestroy() {
    this.examDelayMin = 0
    this.loading = true
    this.busy = false
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .headline {
    font-weight: bold;
  }
  .blurb {
    margin-top: 8px;
  }
  .exam-question {
    font-weight: bold;
    margin-top: 5px;
  }

/* https://www.w3schools.com/colors/colors_names.asp */
/* https://www.w3schools.com/colors/colors_mixer.asp?colorbottom=FFC0CB&colortop=FFFFFF */

  .test123 {
    margin-left: 20px;
  }
  .correct {
    background-color: #ccffcc; /* pale green #98FB98 */
  }
  .incorrect {
    background-color: #ffc0cb; /* pink */
  }

  h3 {
    font-size: 1.4rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Exam.vue